<template>
  <div
    id="app"
    target="_blank"
    >
    
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>-->
    <router-view class="container-fluid" />
  </div>
</template>

<script>
// const authToken = localStorage.getItem("OXA6QmzhAb2BBBtV");
// const authToken = token.getAttribute("data-token");
const authToken =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwYXlsb2FkIjp7InNjb3BlIjoicmVhZCIsImNsaWVudElkIjoxNzh9LCJpYXQiOjE2MTc4MDgyNjB9.CdcowZEM4NQbJc1bifzkeeoflS4Tzq7-lSYAqpPICPU";
export default {
  name: "app",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
    };
  },

  mounted() {
      
    // categories
    const categoriesParams = {
      auth_token: authToken,
    };
    this.$store.dispatch("getCategories", categoriesParams);
    const unitParams = {
      auth_token: authToken,
    };
    this.$store.dispatch("getUnits", unitParams);

    const availabilityParams = {
      auth_token: authToken,
    };
    this.$store.dispatch("getAvailability", availabilityParams);

    const ratesParams = {
      auth_token: authToken,
    };
    this.$store.dispatch("getRates", ratesParams);

    const amenityParams = {
      auth_token: authToken,
    };
    this.$store.dispatch("getAmenities", amenityParams);
  },
};
</script>


<style lang="scss">
@font-face {
    font-family: 'bradleyhanditc';
    src: url('./assets/bradleyhanditc.eot');
    src: url('./assets/bradleyhanditc.woff') format('woff'),
         url('./assets/bradleyhanditc.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;

}
@font-face {
  font-family: 'rockwellregular';
  src: url('./assets/rock-webfont.eot');
  src: url('./assets/rock-webfont.eot?#iefix') format('embedded-opentype'),
       url('./assets/rock-webfont.woff') format('woff'),
       url('./assets/rock-webfont.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;

}


@font-face {
  font-family: 'rockwellbold';
  src: url('./assets/rockb-webfont.eot');
  src: url('./assets/rockb-webfont.eot?#iefix') format('embedded-opentype'),
       url('./assets/rockb-webfont.woff') format('woff'),
       url('./assets/rockb-webfont.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;

}
@font-face {
  font-family: 'display-patrol';
  src: url('./assets/fonts/1452Display-Patrol.woff2') format('woff2'),
    url('./assets/fonts/1452Display-Patrol.woff') format('woff');
  font-display: auto;
}

.display-patrol {
  font-family: 'display-patrol' !important;
}

@font-face {
  font-family: 'bray-notes';
  src: url('./assets/fonts/628Bray-Notes.woff2') format('woff2'),
    url('./assets/fonts/628Bray-Notes.woff') format('woff');
  font-display: auto;
}

.bray-notes {
  font-family: 'bray-notes' !important;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  // display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.reports a {
  font-size: 14px;
}
</style>
